import {
  firestore,
  getDoc,
  doc,
  query, 
} from '../../utils/firestore'
import { timeSheetsCollectionName } from '../common/appConstants'

export const getTimeSheets = async (timeSheetId) => {
  // const docQuery = query(collection(firestore, timeSheetsCollectionName))
  const docQuery = query(doc(firestore, `${timeSheetsCollectionName}/${timeSheetId}`))
  return getDoc(docQuery)
}